module.exports = __webpack_public_path__ + "img/icon_sm_htcx.6b289a99.png";